import { russianEndings } from './string';

export const secondsToTime = (seconds: number) => {
  return new Date(seconds * 1000).toUTCString().match(/(\d\d:\d\d:\d\d)/)?.[0];
};

export const stringToSeconds = (string?: string) => {
  const colons = string ? string.split(':') : [];
  return +colons[0] * 60 * 60 + +colons[1] * 60 + +colons[2];
};

export const toHoursAndMinutes = (seconds: number, hasComa?: boolean) => {
  const secondsLeft = russianEndings(Math.round(seconds), [' секунда ', 'секунды ', 'секунд']);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const minutesLeft = minutes % 60;
  const hoursRender = hours >= 1 ? hours + russianEndings(hours, [' час', ' часа', ' часов']) : '';
  const minutesRender =
    minutesLeft >= 1
      ? minutesLeft + russianEndings(minutesLeft, [' минута', ' минуты', ' минут'])
      : '';
  return seconds < 60
    ? Math.floor(seconds) + ' ' + secondsLeft
    : hasComa
    ? `${hoursRender}${minutesRender && hoursRender ? ' ' : ''}${minutesRender},`
    : `${hoursRender}${minutesRender && hoursRender ? ' ' : ''}${minutesRender}`;
};
